const personaEnums = new Map();

personaEnums.set(1, 'RETAILING');
personaEnums.set(9, 'TRADING');
personaEnums.set(5, 'FARMING');

export default personaEnums;
